import { getHsLocaleHeader } from 'hs-locale-management';
import { chirpGateways } from './constants';
import { ChirpGateway } from './types';

/**
 * Get the standard headers for a given Chirp Gateway type.
 *
 * TODO: Some cookie logic is duplicated in hub-http, quick-fetch and elsewhere. It should be centralized.
 */
export function getStandardHeaders(
  gateway: ChirpGateway,
  cookie: string
): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  switch (gateway) {
    case chirpGateways.APP: {
      const csrfToken = getCookie('csrf.app', cookie);
      if (csrfToken) {
        headers['X-HubSpot-CSRF-hubspotapi'] = csrfToken;
      }

      Object.assign(headers, getHsLocaleHeader());
      break;
    }
    case chirpGateways.TEST:
    case chirpGateways.INTERNAL: {
      const infraIdpCookie = getCookie('hs_tools_auth_idp', cookie);
      if (infraIdpCookie) {
        const { idptok } = JSON.parse(decodeURIComponent(infraIdpCookie));
        headers['Authorization'] = `Bearer ${idptok}`;
      }
      break;
    }
    case chirpGateways.EXTERNAL:
      // For external gateway, don't add any HubSpot auth headers
      break;
    default:
  }

  return headers;
}

/**
 * Get a cookie value by name, if it exists.
 *
 * TODO: quick-fetch, hub-http, and other places have their own ways for reading cookies but it should be centralized.
 */
function getCookie(name: string, cookie: string): string | undefined {
  const matches = cookie.match(`(?:^|;\\s*)${name}=(.*?)(?:;|$)`);
  if (!matches) {
    return undefined;
  }

  return decodeURIComponent(matches[1]);
}
